import { FileInterface } from "../types/RecordInterfaces";
import AppSpinner from "./AppSpinner";
import useFilePreview from "../api/api-hooks/records/useFilePreview";
import Preview from "../utils/Preview";
import { Alert } from "reactstrap";

interface Props {
  file: FileInterface;
}

const DynamicFilePreview = ({ file }: Props) => {
  const { fileSource, loading, previewError, fileType, extension } =
    useFilePreview(file);

  return (
    <div className="d-flex justify-content-center align-items-center w-100 h-100">
      {loading ? (
        <AppSpinner
          style={{ height: "150px", width: "150px", fontSize: "38px" }}
        />
      ) : (
        <>
          {!previewError ? (
            <Preview
              type={fileType}
              mode="record"
              value={{ ...file, source: fileSource }}
              extension={extension}
              modal
            />
          ) : (
            <Alert color="light">No preview available for this file.</Alert>
          )}
        </>
      )}
    </div>
  );
};

export default DynamicFilePreview;
